import { render, staticRenderFns } from "./AuvStatusWidget.vue?vue&type=template&id=225cdf66&scoped=true"
import script from "./AuvStatusWidget.vue?vue&type=script&lang=js"
export * from "./AuvStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./AuvStatusWidget.vue?vue&type=style&index=0&id=225cdf66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225cdf66",
  null
  
)

export default component.exports